import { createBasicInformationTab } from './tabs/basic-information-tab'
import { createLocationContactTab } from './tabs/location-contact-tab'
import { createPracticeDetailsTab } from './tabs/practice-details-tab'
// import { createCGMIntegrationTab } from './tabs/cgm-integration-tab' // Disabled - not currently used
import { createBillingProfileTab } from './tabs/billing-profile-tab'
import { createBillingMacrosTab } from './tabs/billing-macros-tab'
import ServicesOfferedTab from './tabs/services/services-offered-tab'
import ServicesConfigTab from './tabs/services/services-config-tab'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { Badge, Form, Modal, Select } from 'antd'
import {
  CLINIC_FORM_CATEGORY_ICONS,
  CLINIC_FORM_CATEGORY_COLORS,
  CLINIC_FORM_CATEGORY_LABELS
} from '../config/form-categories'
import { clinicTabsEnums } from '../config/clinic-tabs-enums'

export const clinicFormTabs = (props) => {
  const handleTabChange = props.handleTabChange
  const practiceName = props.data.practiceName || props.basicInfoForm.getFieldValue('practiceName')
  const { token, unfilledFields } = props
  return [
    createBasicInformationTab({
      ...props
    }),
    createLocationContactTab({
      ...props
    }),
    createPracticeDetailsTab({
      ...props
    }),
    // createCGMIntegrationTab(props), // Disabled - CGM integration not currently used
    // Services Offered Tab
    {
      key: clinicTabsEnums.SERVICES_OFFERED,
      disabled: !props.practiceDetailsDataValid || !props.locationDataValid || !props.basicInfoValid,
      label: (
        <span>
          <FontAwesomeIcon
            icon={CLINIC_FORM_CATEGORY_ICONS.SERVICES_OFFERED}
            style={{ marginRight: '8px', color: CLINIC_FORM_CATEGORY_COLORS.SERVICES_OFFERED }}
          />
          {CLINIC_FORM_CATEGORY_LABELS.SERVICES_OFFERED}
          <Badge count={unfilledFields[4]} style={{ marginLeft: '8px', backgroundColor: token.colorError }} />
        </span>
      ),
      children: (
        <>
          <ServicesOfferedTab {...props} />
          <Form
            form={props.servicesOfferedForm}
            onFinish={props.handleFormSubmit}
            onFinishFailed={(errorInfo) => {
              Modal.error({
                title: 'Form Validation Error',
                content: errorInfo.errorFields[0].errors[0]
              })
            }}
            name='form'
            initialValues={{
              ...props.recordData
            }}
            layout='vertical'
            onValuesChange={(changedFields, allFields) => {
              props.handleValuesChange(changedFields, allFields)
            }}
          >
            <Form.Item
              name='servicesOffered'
              hidden
              rules={[
                {
                  required: true,
                  message: 'Please select atleast one service to offer. You can come back and change this later.'
                }
              ]}
            >
              <Select options={[]} />
            </Form.Item>
          </Form>
        </>
      )
    },
    // Configure Services Tab
    {
      key: clinicTabsEnums.SERVICES_CONFIG,
      disabled:
        !props.servicesOfferedDataValid ||
        !props.practiceDetailsDataValid ||
        !props.locationDataValid ||
        !props.basicInfoValid,
      label: (
        <span>
          <FontAwesomeIcon icon={faCog} style={{ marginRight: '8px', color: '#722ed1' }} />
          Configure Services
          <Badge count={unfilledFields[5]} style={{ marginLeft: '8px', backgroundColor: token.colorError }} />
        </span>
      ),
      children: (
        <>
          <ServicesConfigTab {...props} />
        </>
      )
    },
    createBillingProfileTab({
      ...props,
      handleTabChange,
      disabled:
        !props.servicesConfigDataValid ||
        !props.servicesOfferedDataValid ||
        !props.practiceDetailsDataValid ||
        !props.locationDataValid ||
        !props.basicInfoValid,
      schemesLoading: props.schemesLoading,
      schemeOps: props.schemeOps,
      clinicId: props.data._id,
      practiceName: practiceName,
      handleValuesChange: props.handleValuesChange
    }),
    {
      ...createBillingMacrosTab({
        ...props,
        disabled:
          !props.servicesConfigDataValid ||
          !props.servicesOfferedDataValid ||
          !props.practiceDetailsDataValid ||
          !props.locationDataValid ||
          !props.basicInfoValid ||
          !props.billingProfileDataValid
      })
    }
  ]
}
